import React, {  useEffect } from 'react';
import {  useHistory, useParams } from 'react-router-dom';

import CharterRequest from '../EntityList/CharterRequestsSupplier'
import ClientDepartmentDetail from '../Editors/ClientDepartmentDetail';
import ClientStaffList from '../EntityList/ClientStaffList';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { ClientDepartmentMessageLog } from '../EntityList/ViewMessageLog';
import { useFormikContext } from 'formik';
import { useAuth } from '../../Services/AuthContext';
import MarginDetails from '../Editors/MarginDetails';
import { useEdit } from '../../Services/EditContext';
import TimeLine from '../EntityList/TimeLine';

const ClientDepartmentEditor = ({route ,isNewItem }) => {
    const params = useParams();
    const { clientDepartmentId, departmentAction } = params;
    const { values } = useFormikContext();
    const [auth] = useAuth()
    const { push } = useHistory();
    const { id } = values;
    const [edit] = useEdit(); 
    useEffect(() => {
        if (edit && clientDepartmentId && params?.departmentAction !== 'Detail') {
            push(route + '/' + clientDepartmentId + '/Detail');
        }
    }, [edit, clientDepartmentId, params,route, push]);



    const itemParam = params.list === 'Department' ? 'clientDepartmentId' : 'clientStaffId';


    const setActiveKey = (tab) => {
        push(route + '/' + clientDepartmentId + '/' + tab);
    }
    const differentRoute = departmentAction !== 'Staff' && departmentAction !== 'Charters' && departmentAction !== 'Margin' && departmentAction !== 'Messages';
    return <Tabs activeKey={departmentAction} style={{ height: '100%' }} onSelect={setActiveKey}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            {differentRoute ? <ClientDepartmentDetail invite={isNewItem} edit={edit} route={route + '/' + id + '/Detail'} /> : null}
        </Tab>
        {!edit && <Tab key={'Staff'} eventKey={'Staff'} title='Staff' style={{ height: '600px' }} >
            {departmentAction === 'Staff' ? <ClientStaffList item={values} route={route + '/' + id + '/' + departmentAction} parentHeight={400} headerHeight={60} /> : null}
        </Tab>
        }
        {!edit && <Tab key={'Charters'} eventKey={'Charters'} title='Charters' style={{ height: '600px' }} >
            {departmentAction === 'Charters' ? <CharterRequest item={values} area='department' route={route + '/' + id + '/' + departmentAction}  parentHeight={400} /> : null}
        </Tab>}
        {auth && auth.role === 'Admin' && !edit && <Tab key={'Margin'} eventKey={'Margin'} title='Margin' style={{ height: '400px' }} >
            {departmentAction === 'Margin' ? <MarginDetails id={id} route={route + '/' + id + '/' + departmentAction} item={values} parentHeight={400} /> : null}
        </Tab>}
        {!edit && <Tab key={'Messages'} eventKey={'Messages'} title='Messages' style={{ height: '600px' }} >
            {departmentAction === 'Messages' ? <ClientDepartmentMessageLog item={values} route={route + '/' + id + '/' + departmentAction} itemParam={itemParam} clientDepartmentId={id} parentHeight={400} headerHeight={60} /> : null}
        </Tab>
        }
        {!edit && <Tab key={'Timeline'} eventKey={'Timeline'} title='Timeline' style={{ height: '600px' }} >
            {departmentAction === 'Timeline' ? <TimeLine clientCol charterRequestCol  type={"ClientDepartment"} item={values} route={route + '/' + id + "/Timeline"} parentHeight={400} headerHeight={0} /> : null}
        </Tab>
        }
    </Tabs >
}
export default ClientDepartmentEditor;